import React, { useState } from "react";

export default function ManualAttendance() {
  const [email, setEmail] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [employeeData, setEmployeeData] = useState(null);
  const [loading, setLoading] = useState(false);

  const markAttendance = async () => {
    if (!email) {
      showModal("❌ Please enter an email.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://attendance-api.elitewebpro.com/api/attendance/manual", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employee_email: email }),
      });

      const data = await res.json();

      // Show message directly from backend
      showModal(data.message, data.employee || null);

      if (data.success) setEmail("");
    } catch (err) {
      console.error(err);
      showModal("❌ Server error. Please try again.", null);
    } finally {
      setLoading(false);
    }
  };

  const showModal = (message, employee = null) => {
    setModalMessage(message);
    setEmployeeData(employee);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setModalMessage("");
    setEmployeeData(null);
  };

  return (
    <div style={{ textAlign: "center", marginTop: 30 }}>
      <h2>Manual Attendance</h2>
      <input
        type="email"
        placeholder="Enter employee email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ padding: 8, width: 250, marginRight: 10 }}
      />
      <button onClick={markAttendance} disabled={loading}>
        {loading ? "Marking..." : "Mark Attendance"}
      </button>

      {modalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 8,
              textAlign: "center",
              minWidth: 250,
            }}
          >
            <p>{modalMessage}</p>
            {employeeData && (
              <div style={{ marginTop: 10 }}>
                {employeeData.image && (
                  <img
                    src={`https://attendance-api.elitewebpro.com${employeeData.image}`}
                    alt={employeeData.name}
                    style={{ width: 100, borderRadius: "50%", marginBottom: 10 }}
                  />
                )}
                <div><strong>{employeeData.name}</strong></div>
                <div>{employeeData.email}</div>
              </div>
            )}
            <button onClick={closeModal} style={{ marginTop: 10 }}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
